import { createContext } from 'react';
import type { AuthUser } from 'aws-amplify/auth';
import type { UserProfile } from '../types/profile';

export interface AuthContextType {
  user: AuthUser | null;
  userProfile: UserProfile | null;
  firstName: string | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
  loginWithRedirect: () => Promise<void>;
  getCredentials: () => Promise<any>;
  reloadProfile?: () => boolean;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);
